import { sendEmailVerification } from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase";

const FALLBACK_CODES = new Set([
  "functions/not-found",
  "functions/invalid-argument",
  "functions/unavailable",
  "functions/internal",
  "functions/unknown",
  "functions/deadline-exceeded",
]);

/**
 * Sends the verification email from our own sender so it does not land in spam.
 * If the branded sender is unreachable, the Firebase default email is used so
 * the user can still verify.
 */
export async function sendBrandedVerificationEmail(user, { continuePath, fallbackSettings } = {}) {
  try {
    await httpsCallable(functions, "sendTenantVerificationEmail")(
      continuePath ? { continuePath } : {},
    );
  } catch (error) {
    if (!FALLBACK_CODES.has(error?.code)) throw error;
    await sendEmailVerification(user, fallbackSettings);
  }
}
